// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/learning/PatternRecognitionCard.jsx

import React from "react";

const confidencePercent = (confidence) => {
  const value = Number(confidence);
  if (Number.isNaN(value)) return "—";
  const percent = value <= 1 ? value * 100 : value;
  return `${percent.toFixed(0)}%`;
};

export default function PatternRecognitionCard({
  patterns = [],
  connectorPatterns = {},
  frameworkPatterns = {},
  commonBlockers = [],
}) {
  const topPatterns = Array.isArray(patterns) ? patterns.slice(0, 3) : [];
  const connectors = Object.entries(connectorPatterns || {}).slice(0, 4);
  const frameworks = Object.entries(frameworkPatterns || {}).slice(0, 4);

  return (
    <section className="learning-card pattern-recognition-card">
      <div className="learning-card-header">
        <div>
          <p className="learning-eyebrow">Organizational Intelligence</p>
          <h4>Pattern Recognition</h4>
        </div>
        <span className="learning-status-pill">Advisory</span>
      </div>

      <div className="learning-pattern-list">
        {topPatterns.length > 0 ? topPatterns.map((pattern) => (
          <div className="learning-pattern-row" key={pattern.name}>
            <div>
              <strong>{pattern.name}</strong>
              <p>{pattern.description}</p>
              {pattern.advisory_action ? <span>{pattern.advisory_action}</span> : null}
            </div>
            <b>{confidencePercent(pattern.confidence)}</b>
          </div>
        )) : <p className="learning-muted-copy">No repeated patterns detected yet.</p>}
      </div>

      {connectors.length > 0 ? (
        <div className="learning-section-block">
          <h5>Connector patterns</h5>
          <div className="learning-chip-row">
            {connectors.map(([connector, data]) => (
              <span className="learning-chip" key={connector}>
                {connector}: {data?.resolved_count ?? 0} resolved · {data?.validation_success_rate ?? "—"}% validated
              </span>
            ))}
          </div>
        </div>
      ) : null}

      {frameworks.length > 0 ? (
        <div className="learning-section-block">
          <h5>Framework patterns</h5>
          <div className="learning-chip-row">
            {frameworks.map(([framework, data]) => (
              <span className="learning-chip" key={framework}>
                {framework}: {data?.validated_rate ?? "—"}% validated
              </span>
            ))}
          </div>
        </div>
      ) : null}

      {Array.isArray(commonBlockers) && commonBlockers.length > 0 ? (
        <div className="learning-section-block">
          <h5>Common blockers</h5>
          <div className="learning-chip-row">
            {commonBlockers.map((blocker) => (
              <span className="learning-chip learning-chip-warning" key={blocker}>
                {blocker}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
}
